import { useAuth0 } from '@auth0/auth0-react'
import React from 'react'
import { myUserAtom } from '../State/Musician/myUserAtom'
import { useAtom } from 'jotai'
import { Skill } from '../Api/Lirari/Types/skill'
import { Genre } from '../Api/Lirari/Types/genre'
import { Offering } from '../Api/Lirari/Types/offering'
import { PortfolioLink } from '../Api/Lirari/Types/portfolioLinks'

const LogoutButton = () => {
  const { logout } = useAuth0()
  const [, setMyUser] = useAtom(myUserAtom)

  return (
    <button
      onClick={() => {
        setMyUser({
          id: '',
          auth0Id: '',
          firstName: '',
          lastName: '',
          email: '',
          about: '',
          locationFormattedString: '',
          profileImageUrl: '',
          profileAudioUrl: '',
          socialLinks: { youtube: '', spotify: '', soundCloud: '' },
          userSkills: [] as Skill[],
          userGenres: [] as { genre: Genre }[],
          userOfferings: [] as { offering: Offering }[],
          portfolioLinks: [] as PortfolioLink[],
        })
        logout({ logoutParams: { returnTo: window.location.origin } })
      }}
    >
      Log Out
    </button>
  )
}

export default LogoutButton
